module.exports = __webpack_public_path__ + "static/media/coins.a80c78fe.svg";